// extracted by mini-css-extract-plugin
module.exports = {"swapWithIPFSCompleted":"SwapWithIPFSCompletedContent_swapWithIPFSCompleted__SOG10"};